//@TODO: move util to the appropiate level

import { HEALTH_STATUS_SCORE } from '@/constants/shared/healthStatusScore';
import { SENSORS_DATA_TYPE } from '@/const';

/**
 * Check if a component has camera capability based on its diagnostics data
 * This matches the original logic: check hasCamera property first, then fall back to diagnostics
 * @param component - The component object to check
 * @returns true if the component has camera data, false otherwise
 */
export const componentHasCamera = (component: any): boolean => {
  if (!component) return false;

  // Use OR logic to match original behavior:
  // Trust hasCamera property if truthy, otherwise check diagnostics as fallback
  return !!(
    component.hasCamera ||
    component.diagnostics?.some((diag: any) =>
      diag.sources_info?.some((src: any) =>
        src.source_type.toLowerCase() === SENSORS_DATA_TYPE.Camera.toLowerCase()
      )
    )
  );
};

export const sortComponentsByName = (items: any[], sortField: string) => {
  if (!items) return [];
  if (!items || items.length === 0) return [];
  return [...items].sort((a: any, b: any) => {
    return a?.[sortField].localeCompare(b?.[sortField]);
  });
};

export const sortComponentsByHealthStatusAndName = (items: any, sortField?: string) => {
  if (!items || items.length === 0) return [];

  return [...items].sort((a: any, b: any) => {
    // Sort by health status first
    if (a?.health_status && b?.health_status) {
      const tmpA = a.not_monitored ? a.health_status + '_na' : a.health_status;
      const tmpB = b.not_monitored ? b.health_status + '_na' : b.health_status;

      const scoreA = HEALTH_STATUS_SCORE[tmpA.toLowerCase() as keyof typeof HEALTH_STATUS_SCORE] || 0;
      const scoreB = HEALTH_STATUS_SCORE[tmpB.toLowerCase() as keyof typeof HEALTH_STATUS_SCORE] || 0;

      // Higher score comes first (critical=9 before alarm=7 before monitor=5 before healthy=3)
      if (scoreA !== scoreB) {
        return scoreB - scoreA;
      }
    }

    // Then sort by name
    const stringField = sortField ||
      (a?.subcomponent_ui_name ? 'subcomponent_ui_name' :
       a?.component_ui_name ? 'component_ui_name' :
       a?.component_name ? 'component_name' :
       a?.component?.component_name ? 'component.component_name' :
       a?.asset_name ? 'asset_name' :
       a?.source?.source_type ? 'source.source_type' :
       a?.source_type ? 'source_type' :
       'fault_type');

    // Handle nested field access and missing fields
    const getFieldValue = (obj: any, field: string) => {
      if (!obj) return null;
      if (field.includes('.')) {
        const parts = field.split('.');
        return obj[parts[0]]?.[parts[1]];
      }
      return obj[field];
    };

    const aValue = getFieldValue(a, stringField);
    const bValue = getFieldValue(b, stringField);

    if (!aValue && !bValue) return 0;
    if (!aValue) return 1;
    if (!bValue) return -1;

    return aValue.localeCompare(bValue);
  });
};
